import Video from '../components/Video';

export default class DynamicVideo {
  constructor(section) {
    const videoEl = section.el.querySelector('[data-video]');
    this.$el = section.el;

    this.autoplay = section.data.autoplay;
    this.hasPlayed = false;

    if (videoEl) {
      this.video = new Video(videoEl);
      this.bindEvents();
    }
  }

  bindEvents() {
    window.addEventListener('scroll', () => {
      if (this.autoplay) {
        var rect = this.$el.getBoundingClientRect();

        if (rect.top >= 0 || rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) {
          if (!this.hasPlayed) {
            this.video._autoplay();
            this.hasPlayed = true;
          }
        } else {
          this.video._onPauseClick();
        }
      }
    });
  }

  onSectionUnload() {
    if (this.video) {
      this.video.unload();
    }
  }
}
